let appconfig = {
  environment: "production",
  Host: "https://pro.btb.co.ua/",
  Point: "https://dev.btb.co.ua/",
  HostDev: "https://pro.btb.test/",
  PointDev: "http://btb.test:8080/",
  apiPoint: "api/constructor/v1/",
  createOrder: "api/constructor/v1/create/order",
  isLocal: process.env.VUE_APP_IS_LOCAL,
};

if (location.host === "localhost") {
  appconfig.Host = "https://btb.test/";
  appconfig.Point = "https://btb.test:8080/";
} else if (location.host === "pro.btb.test") {
  appconfig.Host = "https://pro.btb.test/";
  appconfig.Point = "https://btb.test:8080/";
} else if (location.host === "pro.btb.co.ua") {
  appconfig.Host = "https://pro.btb.co.ua/";
  appconfig.Point = "https://dev.btb.co.ua/";
} else if (location.host === "pro.mm.ck.ua") {
  appconfig.Host = "https://pro.mm.ck.ua/";
  appconfig.Point = "https://mm.ck.ua/";
}

if (appconfig.isLocal) {
  appconfig.Host = appconfig.HostDev;
  appconfig.Point = appconfig.PointDev;
}

export default appconfig;
